// Guard changes to an overflow menu's open state, preventing closing when focus is inside any nested dialog.
// see https://github.com/github/primer/issues/5896#issuecomment-3335244847
export function guardOverflowMenuChange(
  next: boolean,
  setOpen: (open: boolean | undefined) => void,
  {container = document.body}: {container?: ParentNode} = {},
) {
  if (!next) {
    const overflowMenu = container.querySelector<HTMLElement>('[data-overflow-menu-overlay]')
    if (overflowMenu) {
      const openDialogs = Array.from(container.querySelectorAll<HTMLElement>('[role="dialog"]'))
      for (const dialog of openDialogs) {
        // If the dialog is visible do not close the overflow menu. The only dialogs that would
        // be open in this scenario are dialogs triggered from within the overflow menu.
        const {width, height} = dialog.getBoundingClientRect()
        const isDialogVisible = dialog.hasAttribute('data-visibility-visible') || width || height
        if (isDialogVisible) return
      }
    }
  }
  setOpen(next)
}

export type GuardOverflowMenuChange = typeof guardOverflowMenuChange
